/**
 * @version: v 1.0.0
 * @Author: zengying
 * @Date: 2022/9/23 10:24
 * @FileName: index.js
 * @LastEditor: 2022/9/23 10:24
 * @Name: index
 */

import Vue from 'vue';
import Router from 'vue-router';
import ElementUI from 'element-ui';

// router
import home from './home'; // 首页
import ourAdvantages from './OurAdvantages'; // 我们的优势
import aboutUs from './aboutUs'; // 关于我们
import businessIntroduction from './businessIntroduction'; // 业务介绍
import realTimeCurrency from './realTimeCurrency'; // 实时汇率
import contactUs from './contactUs'; // 联系我们
import news from './news'; // 最新资讯
import foreignExchange from './foreignExchange'; // 联系我们
import internationalRemittance from './internationalRemittance'; // 国际汇款
import openAnAccountOnline from './openAnAccountOnline'; // 在线开户
import questionAndAnswer from './questionAndAnswer'; // 常见问题

Vue.use(Router);
Vue.use(ElementUI);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

let routeList = [
  home.routes,
  news.routes,
  ourAdvantages.routes,
  aboutUs.routes,
  businessIntroduction.routes,
  realTimeCurrency.routes,
  contactUs.routes,
  foreignExchange.routes,
  internationalRemittance.routes,
  openAnAccountOnline.routes,
  questionAndAnswer.routes
];

let routes = [];


//拼接路由
routeList.map(s => {
  routes = routes.concat(s);
});

const router = new Router({
  routes: routes
});

router.beforeEach((to, from, next) => {
  const loading = ElementUI.Loading.service({
    lock: true,
    text: '加载中',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });

  next();
});

router.afterEach(route => {
  const loading = ElementUI.Loading.service({
    lock: true,
    text: '加载中',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });
  //将滚动条恢复到最顶端
  window.scrollTo(0, 0);
  setTimeout(() => {
    loading.close();
    // window.location.reload()
  }, 200);
});

export default router;



// WEBPACK FOOTER //
// ./src/project/router/index.js